import react from "react";
import { Box, Typography } from "@mui/material";
import muiTheme from "../../../../themes/muiTheme";

interface Props {
  sectionPage: number;
  currentPage: number;
  title: string;
  viewWidth: number;
  isOpen: boolean;
  isPortrait: boolean;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  closeDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}
export const SubSectionButton = ({
  sectionPage,
  currentPage,
  title,
  viewWidth,
  isOpen,
  isPortrait,
  setPage,
  closeDrawer,
}: Props) => {
  return (
    <Box
      onClick={() => {
        if (sectionPage < 0) {
          return;
        }
        if (isPortrait) {
          closeDrawer(!isOpen);
        }
        setPage(sectionPage);
      }}
      sx={{
        display: "flex",
        width: !isPortrait ? 184 : viewWidth - 56,
        px: 1.2,
        py: 0.4,
        cursor: "pointer",
        userSelect: "none",
        ":hover": {
          backgroundColor: isPortrait ? null : muiTheme.palette.grey[200],
        },
      }}
    >
      <Typography
        variant={isClickedSection(currentPage, sectionPage) ? "tm-b" : "tm-r"}
        color={
          isClickedSection(currentPage, sectionPage)
            ? muiTheme.palette.blue[500]
            : muiTheme.palette.grey[900]
        }
      >
        {title}
      </Typography>
    </Box>
  );
};

function isClickedSection(currentPage: number, sectionPage: number) {
  return currentPage === sectionPage;
}
